import MdRadio from "./MdRadio"

const MdRadioPlugin = {
  install(app) {
    app.component(MdRadio.name, MdRadio)
  },
}

export default MdRadioPlugin
